<template>
    <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
        <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  g-py-10">
                        <multiselect v-model="searchValues.Color" :options="color" :multiple="true" deselectLabel=" " selectedLabel=" " placeholder="Color" selectLabel=" ">
                            <span slot="noResult">No elements found.</span>
                        </multiselect>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  g-py-10">
                        <multiselect v-model="SelectedFrameType" :options="frameType" track-by="code" label="name" :multiple="true" deselectLabel=" " selectedLabel=" " placeholder="Frame Type" selectLabel=" ">
                            <span slot="noResult">No elements found.</span>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 form-inline">
                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 center">
                    <div class="row">
                        <div class="col-lg-12 form-inline">
                            <div class="eye-size-range-div">
                                <p class="g-font-size-14">Eye Size Range</p>
                            </div>
                            <input v-model="searchValues.MinRange" v-on:keyup.enter="Search()" class="form-control max-width-number g-my-15" type="number">
                            <span class="mar-right-left-10">To</span>
                            <input v-model="searchValues.MaxRange" v-on:keyup.enter="Search()" class="form-control max-width-number g-my-15" type="number">
                            <p v-if="(searchValues.MinRange < 35 || searchValues.MaxRange < 35) || (searchValues.MinRange > 70 || searchValues.MaxRange > 70)" class="error-message">Eye size should be between 35 to 70</p>
                        </div> 
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12" style="background-color: ">
                    <button v-on:click="Search()" v-bind:disabled="searchValues.MinRange < 35 || searchValues.MaxRange < 35 || searchValues.MinRange > 70 || searchValues.MaxRange > 70" class="btn g-bg-main g-bg-main-blue--hover g-color-white text-uppercase g-rounded-10">Search</button>
                    <button v-on:click="Reset()" class="btn u-btn-primary text-uppercase g-rounded-10">Reset</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
    props:['searchValues'],
    components: {Multiselect},
    data() {
        return {
            color:[],
            frameType:[],
            SelectedFrameType:null
        }
    },
    methods: {
        GetEnums(){
            var _this = this;
            axios.get('frame/GetEnum/', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.color = response.data.raw.color;
                    // _this.frameType = response.data.raw.frameType;
                })
                .catch(function (error) {
                console.log(error);
                });
        },
        GetFrameType() {
            var _this = this;
            axios
            .get("/Order/Catalog/ListFrame", {
            headers: { Authorization: "Bearer " + localStorage.getItem("token") }
            })
            .then(function(response) {
            _this.frameType = response.data.raw;
            })
            .catch(function(error) {
            console.log(error);
            });
        },
        Search(){
            this.searchValues.FirstLoad = false;
            this.$emit("clicked");
        },
        Reset(){
            this.$emit('reset');
        }
    },
    watch: {
        SelectedFrameType(val){
            this.searchValues.FrameType = []
            val.forEach(e => {
                if(typeof e === 'string' || e instanceof String){
                    this.searchValues.FrameType.push(e)
                } else {
                    this.searchValues.FrameType.push(e.code)
                }
            });
        }
    },
    created(){
        this.GetEnums();
        this.GetFrameType();
        
    }
}
</script>


// WEBPACK FOOTER //
// FrameFilters.vue?33d3f18f